// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"725":"718e76c2","727":"cf282507","996":"965a6706"}[chunkId] + ".chunk.js";
};